<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">返程设置</div>
		</div>
		<div class="setup">
			<div>返程费收取方式：</div>
			<div style="padding: 0 0.625rem;">
				<el-switch v-model.nnumber="area_type" @change="changeTypeArea" active-text="按订单里程"
					inactive-text="按区域范围" :active-value="1" :inactive-value="0">
				</el-switch>
			</div>
			<div style="margin-left: 1rem;">订单里程超过</div>
			<div style="width: 8rem;padding: 0 0.625rem;">
				<el-input-number style="width: 100%;" v-model.number="area_km" controls-position="right" :min="0"
					:max="100" :precision="3" size="small" @change="changeKmArea">
				</el-input-number>
			</div>
			<div>公里加收返程费</div>
			<div style="font-size: 0.75rem;color: #999;margin-left: 0.625rem;">(若设为0，则按以下区域范围收取)</div>
		</div>
		<div class="grid-content-operate" style="display: flex;">
			<el-button @click="addArea" size="small">
				<i class="el-icon-circle-plus"></i>
				<span>添加区域</span>
			</el-button>
			<el-button type="primary" size="small" @click="submitSaveArea">保存设置</el-button>
		</div>
		<div class="grid-content-content">
			<div class="map" v-loading="loading">
				<el-amap :amap-manager="map.amapManager" vid="amap" :center="map.center" :zoom="map.zoom"
					:events="map.events">
				</el-amap>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		AMapManager,
		lazyAMapApiLoaderInstance
	} from "vue-amap";
	let amapManager = new AMapManager();
	var polyEditor = null;
	export default {
		data() {
			const self = this;
			return {
				loading: true,
				polygon: null,
				area_type: 0,
				area_km: 0,
				map: {
					amapManager,
					center: [116.397428, 39.909231],
					zoom: 14,
					events: {
						init() {
							lazyAMapApiLoaderInstance.load().then(() => {
								self.postArea();
							});
						}
					}
				}
			};
		},
		methods: {
			changeTypeArea(e) {
				this.area_km = (e > 0) ? 1 : 0;
			},
			changeKmArea(e) {
				this.area_type = (e > 0) ? 1 : 0;
			},
			addArea() {
				const that = this;
				let map = that.map.amapManager.getMap();
				if (map) {
					that.$confirm('添加区域之前需要清空原区域，是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(res => {
						var polygon = [];
						var center = map.getCenter();
						polygon.push([center.lng + 0.015, center.lat + 0.015])
						polygon.push([center.lng + 0.015, center.lat - 0.015])
						polygon.push([center.lng - 0.015, center.lat - 0.015])
						polygon.push([center.lng - 0.015, center.lat + 0.015])
						that.applyArea(polygon);
					}).catch(e => {
						if (e != "cancel") {
							that.$message.error("添加失败，请重试");
						}
					});
				} else {
					that.$alert("地图尚未初始化，请稍后重试", '提示', {
						type: 'error',
						confirmButtonText: '确定'
					});
				}
			},
			submitSaveArea() {
				if (polyEditor == null) {
					this.$message.error("保存失败，区域错误");
				} else {
					polyEditor.close();
				}
			},
			//渲染区域
			applyArea(polygon) {
				const that = this;
				let map = that.map.amapManager.getMap();
				map.clearMap();
				//装载区域
				var polyData = new AMap.Polygon({
					path: polygon, // 设置线覆盖物路径
					strokeColor: "#00aeff",
					fillOpacity: 0.4,
					fillColor: '#1791fc',
					zIndex: 50
				});
				map.add([polyData]);
				map.setFitView();
				polyEditor = new AMap.PolyEditor(map, polyData);
				polyEditor.open();
				polyEditor.on('end', function(event) {
					polyEditor.open();
					var polygons = [];
					var path = event.target.w.path;
					for (var i = 0; i < path.length; i++) {
						polygons.push([path[i]['lng'], path[i]['lat']])
					}
					that.$post('operateArea', {
						mode: "save",
						area_km: that.area_km,
						area_polygon: polygons
					}).then(res => {
						that.$message.success("保存成功");
						setTimeout(function() {
							that.postArea();
						}, 500);
					}).catch(e => {
						that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
							"未知错误，请重试", '提示', {
								type: 'error',
								confirmButtonText: '确定'
							});
					});
				});
			},
			postArea() {
				const that = this;
				that.loading = true;
				that.$post('operateArea').then(res => {
					setTimeout(function() {
						that.loading = false;
						that.area_type = (res.data.area_km > 0) ? 1 : 0;
						that.area_km = res.data.area_km;
						if (res.data.area.length > 0) {
							that.applyArea(res.data.area);
						} else {
							that.map.center = [res.data.lng, res.data.lat];
						}
					}, 500);
				}).catch(e => {
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.setup {
		display: flex;
		align-items: center;
		padding: 0 0.8rem;
		min-width: 12.5rem;
		height: 3.2rem;
		font-size: 0.875rem;
		border-radius: 0.25rem;
		margin-top: 1.25rem;
		background-color: #eff8fe;
		border: 1px #ebeef5 solid;
	}

	.map {
		height: 38rem;
	}
</style>
